import React, { useContext, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Modality } from '@prisjakt/ui/modality';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import FilterIcon from 'mdi-react/FilterVariantIcon';
import { ProductCollectionNonNameSearchFilter } from '../filter/types';
import { AggregationSection } from '../../../../types';
import FeaturedFilter from './featured-filter';
import AppliedFilters from '../filter/applied-filters';
import { trackProductCollectionQuickFilterOpen } from '../../tracking';
import sidebarActions from '../../../sidebar/actions/filter';

import * as S from './styles';

type Props = {
  filters: ProductCollectionNonNameSearchFilter[];
  sections: AggregationSection[];
  clearFilter: (property?: string) => void;
};

const filterIcon = <FilterIcon />;

const FeaturedFilters = ({ filters, sections, clearFilter }: Props) => {
  const { t } = useContext(AppContext);
  const [currentOpenFilter, setOpenFilter] = useState(null);
  const [modalIsActive, setModalActive] = useState(false);

  const dispatch = useDispatch();
  const toggleFilter = useCallback(
    () => dispatch(sidebarActions.toggleFilter()),
    [dispatch]
  );

  const onFilterToggle = useCallback(
    id => {
      const newCurrentFilter = currentOpenFilter === id ? null : id;
      setOpenFilter(newCurrentFilter);
      setModalActive(newCurrentFilter !== null);
      if (newCurrentFilter) {
        trackProductCollectionQuickFilterOpen(
          (sections.find(item => item.id === id) || { property: id }).property
        );
      }
    },
    [currentOpenFilter, sections]
  );
  const onCloseRequested = useCallback(() => {
    setOpenFilter(null);
    setModalActive(false);
  }, []);
  return (
    <S.FeaturedFiltersWrapper>
      <Modality modal={modalIsActive} onLeaveRequested={onCloseRequested}>
        <S.FeaturedFilters>
          {sections.map(section => (
            <FeaturedFilter
              key={section.id}
              id={section.id}
              section={section}
              onToggle={onFilterToggle}
              isOpen={section.id === currentOpenFilter}
              clearFilter={clearFilter}
              appliedFilters={filters}
            />
          ))}
          <Button
            size="small"
            color="primary"
            variant="text"
            iconPosition="right"
            icon={filterIcon}
            onClick={toggleFilter}
            data-test="FeaturedFilterMoreFiltersButton"
          >
            <S.FeaturedFilterButtonText>
              {t('filter', 'filter.show-more-filters')}
            </S.FeaturedFilterButtonText>
          </Button>
        </S.FeaturedFilters>
      </Modality>
      {filters && filters.length > 0 && (
        <S.AppliedFiltersWrapper data-test="AppliedFiltersWrapper">
          <AppliedFilters
            filters={filters}
            title={`${t('filter', 'applied-filters.title')}:`}
            clearFilter={clearFilter}
          />
        </S.AppliedFiltersWrapper>
      )}
    </S.FeaturedFiltersWrapper>
  );
};

export default FeaturedFilters;
